import { useRef } from 'react';

import { useEventListener } from './useEventListener';

export const useIsKeyPressed = (keyValue) => {
  const isKeyDownRef = useRef(false);
  const handleKeyDown = (event) => {
    const keyValueDown = event.key || 0;
    if (keyValueDown === keyValue) {
      isKeyDownRef.current = true;
    }
  };

  const handleKeyUp = (event) => {
    const keyValueUp = event.key || 0;
    if (keyValueUp === keyValue) {
      isKeyDownRef.current = false;
    }
  };

  useEventListener('keydown', handleKeyDown);
  useEventListener('keyup', handleKeyUp);

  return isKeyDownRef;
};
